var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7927 16.2444C20.2723 15.3481 19.4989 12.8122 19.4989 9.5C19.4989 7.51088 18.7087 5.60322 17.3022 4.1967C15.8957 2.79018 13.988 2 11.9989 2C10.0098 2 8.10214 2.79018 6.69561 4.1967C5.28909 5.60322 4.49891 7.51088 4.49891 9.5C4.49891 12.8131 3.72454 15.3481 3.20423 16.2444C3.07135 16.4722 3.00091 16.7311 3.00001 16.9949C2.9991 17.2586 3.06776 17.518 3.19907 17.7467C3.33037 17.9755 3.51968 18.1656 3.74789 18.2978C3.9761 18.4301 4.23515 18.4998 4.49891 18.5H8.32485C8.49789 19.3467 8.95806 20.1077 9.62754 20.6542C10.297 21.2007 11.1347 21.4992 11.9989 21.4992C12.8631 21.4992 13.7008 21.2007 14.3703 20.6542C15.0398 20.1077 15.4999 19.3467 15.673 18.5H19.4989C19.7626 18.4996 20.0215 18.4298 20.2496 18.2975C20.4777 18.1651 20.6669 17.975 20.7981 17.7463C20.9292 17.5176 20.9978 17.2583 20.9969 16.9946C20.9959 16.7309 20.9255 16.4722 20.7927 16.2444ZM11.9989 20C11.5337 19.9999 11.0801 19.8555 10.7003 19.5869C10.3205 19.3183 10.0333 18.9386 9.87829 18.5H14.1195C13.9645 18.9386 13.6773 19.3183 13.2975 19.5869C12.9178 19.8555 12.4641 19.9999 11.9989 20ZM4.49891 17C5.22079 15.7588 5.99891 12.8825 5.99891 9.5C5.99891 7.9087 6.63105 6.38258 7.75627 5.25736C8.88149 4.13214 10.4076 3.5 11.9989 3.5C13.5902 3.5 15.1163 4.13214 16.2416 5.25736C17.3668 6.38258 17.9989 7.9087 17.9989 9.5C17.9989 12.8797 18.7752 15.7559 19.4989 17H4.49891Z",
    fill: "#727272"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 4,
    r: 2.5,
    fill: "#FF635C",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDot);
export default __webpack_public_path__ + "static/media/notificationDot.e652b951d0bb0374b2ed8ab5bdee05bd.svg";
export { ForwardRef as ReactComponent };